import React, { Component } from 'react';
import {
    CTable,
    CTableHead,
    CTableRow,
    CTableHeaderCell,
    CTableBody,
    CTableDataCell,
    CBadge,
    CSpinner,
    CRow,
    CCol,
    CFormInput,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CFormSelect,
    CFormCheck
} from '@coreui/react'
import {
    cilPencil,
    cilSearch,
    cilPlus,
    cilBan,
    cilCheck,
    cilLockLocked,
    cilLink,
    cilCloudDownload,
    cilStar,
    cilStarHalf} from '@coreui/icons'
import PageHeader from 'src/components/PageHeader'
import AppButton from 'src/components/AppButton'
import TableActions from '../../components/TableActions'
import ServerConnector from 'src/ServerConnector'
import { replaceEmpty } from 'src/util/StringUtil';
import CIcon from '@coreui/icons-react';

class StudentList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            spinner: false,
            student_list: [],
            search_str: "",
            starStudentFilter: false,
            passwordpopup: {
                new_password: "",
                new_passworderr: "",
                confirmpassword: "",
                confirmpassworderr: "",
                visible: false,
                selected_student_seq: -1,
                selected_student_name: "",
                isLoadingSubmit: false
            },
            linkbatchpopup: {
                data: [],
                visible: false,
                selected_student_seq: -1,
                selected_student_name: "",
                selected_batch_seq: -1,
                removeLoadingSeq: -1,
                addButtonLoading: false,
                batch_list: []
            },
            importpopup: {
                visible: false,
                isLoadingSubmit: false,
                file_error: "",
                uploadedFile: null
            },
            importerrorpopup: {
                visible: false,
                message: "",
                error_list: []
            },
            startstudentpopup: {
                data: [],
                visible: false,
                selected_student_seq: -1,
                selected_student_name: "",
                selected_coordinator: -1,
                coordinator_list: [],
                isLoadingSubmit: false,
                isBulk: false,
                selectionErrorMessage: ""
            },
            selectedStudents: []
        };
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        this.setState({
            spinner: true,
            selectedStudents: []
        });
        let connector = new ServerConnector();
        let dataMap = {
            _action_code: "GET_ALL_STUDENTS"
        }

        if (this.state.search_str.length != 0) {
            dataMap["search_str"] = this.state.search_str;
        }

        if (this.state.starStudentFilter) {
            dataMap["is_star"] = "YES";
        }

        connector.postData(dataMap, (data) => { // success
            this.setState({
                spinner: false,
                student_list: data.data
            });
        }, (err_cd, msg, data) => { // failure
            this.setState({
                spinner: false
            });
        })
    }

    confirmStatusChange(user_seq, action) {

        var msg = "Do you want to deactivate this Student?";
        if (action == "REACTIVATION") {
            msg = "Do you want to activate this Student?";
        }

        this.props.showConfirmation(
            "Confirmation",
            msg,
            "Yes",
            "No",
            null,
            () => { this.statusChange(user_seq, action) }
        )
    }

    statusChange(user_seq, action) {

        this.props.showPageSpinner(true);

        var newStatus = "INACTIVE";
        if (action == "REACTIVATION") {
            newStatus = "ACTIVE";
        }

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "SET_STUDENT_STATUS",
            "user_seq": user_seq,
            "status": newStatus
        }
        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            this.props.showAlert("Success", data.msg, "Ok", null, () => {
                this.loadData()
            });
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);
            this.props.showAlert("Error", msg, "Ok", null, null);
        })
    }

    updateSearchInput(event) {

        this.setState({
            search_str: event.target.value
        });
    }

    openPasswordPopup(user_seq, user_name) {

        let passwordpopup = this.state.passwordpopup;
        passwordpopup["visible"] = true;
        passwordpopup["isLoadingSubmit"] = false;
        passwordpopup["new_password"] = "";
        passwordpopup["new_passworderr"] = "";
        passwordpopup["confirmpassword"] = "";
        passwordpopup["confirmpassworderr"] = "";
        passwordpopup["selected_student_seq"] = user_seq;
        passwordpopup["selected_student_name"] = user_name;

        this.setState({
            passwordpopup: passwordpopup
        });
    }

    closePasswordPopup() {

        let passwordpopup = this.state.passwordpopup;
        passwordpopup["visible"] = false;
        passwordpopup["isLoadingSubmit"] = false;
        passwordpopup["new_password"] = "";
        passwordpopup["new_passworderr"] = "";
        passwordpopup["confirmpassword"] = "";
        passwordpopup["confirmpassworderr"] = "";
        this.setState({
            passwordpopup: passwordpopup
        });
    }

    updatePasswordInput(inputField, event) {

        let passwordpopup = this.state.passwordpopup;
        passwordpopup[inputField] = event.target.value;
        passwordpopup[inputField + "err"] = "";
        this.setState({
            passwordpopup: passwordpopup
        });
    }

    validateUpdatePassword() {

        var isValid = true;
        let passwordpopup = this.state.passwordpopup;

        if (this.state.passwordpopup.new_password.length == 0) {

            passwordpopup["new_passworderr"] = "Required";
            isValid = false;
        }

        if (this.state.passwordpopup.confirmpassword.length == 0) {

            passwordpopup["confirmpassworderr"] = "Required";
            isValid = false;
        }

        if (isValid && this.state.passwordpopup.new_password != this.state.passwordpopup.confirmpassword) {

            passwordpopup["confirmpassworderr"] = "Confirm password is not matching with new password";
            isValid = false;
        }

        if (isValid) {

            this.submitUpdatePassword();
        }
        else {

            this.setState({
                passwordpopup: passwordpopup
            });
        }
    }

    submitUpdatePassword() {

        let passwordpopup = this.state.passwordpopup;
        passwordpopup["isLoadingSubmit"] = true;
        this.setState({
            passwordpopup: passwordpopup
        });

        let connector = new ServerConnector();
        let dataMap = {
            _action_code: "UPDATE_STUDENT_PASSWORD",
            user_seq: this.state.passwordpopup.selected_student_seq,
            new_password: this.state.passwordpopup.new_password
        }
        connector.postData(dataMap, (data) => { // success

            this.closePasswordPopup();
            this.props.showAlert("Success", data.msg, "Ok", null, null);

        }, (err_cd, msg, data) => { // failure

            var isHandled = false;
            passwordpopup["isLoadingSubmit"] = false;

            if (data.data) {

                for (let key in data.data) {

                    passwordpopup[key + "err"] = data.data[key];
                }
                isHandled = true;
            }

            this.setState({
                passwordpopup: passwordpopup
            });

            if (!isHandled) {

                this.props.showAlert("Error", msg, "Ok", null, null);
            }
        });
    }

    closeLinkBatchPopup() {

        let linkbatchpopup = this.state.linkbatchpopup;
        linkbatchpopup["visible"] = false;
        linkbatchpopup["data"] = [];
        this.setState({
            linkbatchpopup: linkbatchpopup
        });
    }

    onPopupBatchSelected(event) {

        let linkbatchpopup = this.state.linkbatchpopup;
        linkbatchpopup["selected_batch_seq"] = event.target.value;
        this.setState({
            linkbatchpopup: linkbatchpopup
        });
    }

    addBatchToStudent() {

        if (this.state.linkbatchpopup.selected_batch_seq <= 0) {

            this.props.showAlert("Alert", "Please select batch", "Ok", null, null);
        }
        else {

            let linkbatchpopup = this.state.linkbatchpopup;
            linkbatchpopup["addButtonLoading"] = true;
            this.setState({
                linkbatchpopup: linkbatchpopup
            });

            let connector = new ServerConnector();
            let dataMap = {
                "_action_code": "ASSIGN_STUDENT_BATCH",
                user_seq: this.state.linkbatchpopup.selected_student_seq,
                batch_seq: this.state.linkbatchpopup.selected_batch_seq
            }
            connector.postData(dataMap, (data) => { // success

                linkbatchpopup = this.state.linkbatchpopup;
                linkbatchpopup["addButtonLoading"] = false;
                linkbatchpopup["selected_batch_seq"] = -1;
                this.setState({
                    linkbatchpopup: linkbatchpopup,
                }, () => {

                    this.getLinkBatchPopup(
                        this.state.linkbatchpopup.selected_student_seq,
                        this.state.linkbatchpopup.selected_student_name
                    );
                });
            }, (err_cd, msg, data) => { // failure

                linkbatchpopup = this.state.linkbatchpopup;
                linkbatchpopup["addButtonLoading"] = false;
                this.setState({
                    linkbatchpopup: linkbatchpopup
                });

                this.props.showAlert("Error", msg, "Ok", null, null);
            });
        }
    }

    getLinkBatchPopup(student_seq, student_name) {

        this.props.showPageSpinner(true);

        let linkbatchpopup = this.state.linkbatchpopup;
        linkbatchpopup["selected_student_seq"] = student_seq;
        linkbatchpopup["selected_student_name"] = student_name;
        linkbatchpopup["visible"] = true;

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_STUDENT_BATCHES",
            "user_seq": student_seq
        }
        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            linkbatchpopup["data"] = data.data;

            this.setState({
                linkbatchpopup: linkbatchpopup
            }, () => {
                this.loadBatchForPopup();
            });

        }, (err_id, msg, data) => { // failure

            this.props.showPageSpinner(false);

            if (err_id == "UE048") {

                linkbatchpopup["data"] = [];

                this.setState({
                    linkbatchpopup: linkbatchpopup
                }, () => {
                    this.loadBatchForPopup();
                });
            }
            else {

                this.props.showAlert("Error", msg, "Ok", null, null);
            }
        });
    }

    loadBatchForPopup() {

        let connector = new ServerConnector();
        let dataMap = {
            _action_code: "GET_ALL_BATCHES"
        }

        connector.postData(dataMap, (data) => { // success

            let ignorSeqs = [];
            for (var i = 0; i < this.state.linkbatchpopup.data.length; i++) {
                ignorSeqs[ignorSeqs.length] = this.state.linkbatchpopup.data[i].batch_seq;
            }

            let activeRecords = [];
            for (var i = 0; i < data.data.length; i++) {

                if (data.data[i].status == "ACTIVE" && ignorSeqs.indexOf(data.data[i].batch_seq) == -1) {
                    activeRecords[activeRecords.length] = data.data[i];
                }
            }

            let linkbatchpopup = this.state.linkbatchpopup;
            linkbatchpopup["batch_list"] = activeRecords;
            this.setState({
                linkbatchpopup: linkbatchpopup
            });
        }, (err_cd, msg, data) => { // failure

            let linkbatchpopup = this.state.linkbatchpopup;
            linkbatchpopup["batch_list"] = [];
            this.setState({
                linkbatchpopup: linkbatchpopup
            });
        })
    }

    removeBatch(batch_student_seq) {

        let linkbatchpopup = this.state.linkbatchpopup;
        linkbatchpopup["removeLoadingSeq"] = batch_student_seq;
        this.setState({
            linkbatchpopup: linkbatchpopup
        });

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "DELETE_STUDENT_BATCH",
            batch_student_seq: batch_student_seq
        }
        connector.postData(dataMap, (data) => { // success

            linkbatchpopup = this.state.linkbatchpopup;
            linkbatchpopup["removeLoadingSeq"] = -1;
            this.setState({
                linkbatchpopup: linkbatchpopup
            }, () => {

                this.getLinkBatchPopup(
                    this.state.linkbatchpopup.selected_student_seq,
                    this.state.linkbatchpopup.selected_student_name
                );
            });

        }, (err_cd, msg, data) => { // failure

            linkbatchpopup = this.state.linkbatchpopup;
            linkbatchpopup["removeLoadingSeq"] = -1;
            this.setState({
                linkbatchpopup: linkbatchpopup
            });
            this.props.showAlert("Error", msg, "Ok", null, null);
        });
    }

    getRandomNumber() {

        const min = 1;
        const max = 100;
        const rand = min + Math.random() * (max - min);
        return rand;
    }

    showImportPopup() {

        let importpopup = this.state.importpopup;
        importpopup["visible"] = true;
        importpopup["isLoadingSubmit"] = false;
        importpopup["file_error"] = "";
        importpopup["uploadedFile"] = null;
        this.setState({
            importpopup: importpopup
        });
    }

    closeImportPopup() {

        let importpopup = this.state.importpopup;
        importpopup["visible"] = false;
        this.setState({
            importpopup: importpopup
        });
    }

    updateImportFile(files) {

        if (files) {

            let importpopup = this.state.importpopup;
            importpopup["uploadedFile"] = files[0];
            this.setState({
                importpopup: importpopup
            });
        }
    }

    validateImport() {

        if (this.state.importpopup.uploadedFile) {

            let importpopup = this.state.importpopup;
            importpopup["isLoadingSubmit"] = true;
            this.setState({
                importpopup: importpopup
            });

            let connector = new ServerConnector();
            let dataMap = {
                _action_code: "UPLOAD_STUDENT_DATA"
            }
            let imageHashMap = [];
            imageHashMap.push(this.state.importpopup.uploadedFile);

            connector.postDataMultiPart(dataMap, imageHashMap, (data) => { // success

                this.closeImportPopup();

                if (data.err_cd == "UE056") {

                    if (data.data && data.data.length > 0) {

                        this.openImportErrorPopup(data.msg, data.data);
                    }
                }
                else {

                    this.props.showAlert("Success", data.msg, "Ok", null, () => {
                        this.loadData();
                    });
                }

            }, (err_cd, msg, data) => { // failure

                this.closeImportPopup();
                this.props.showAlert("Success", msg, "Ok", null, null);
            });
        }
        else {

            let importpopup = this.state.importpopup;
            importpopup["file_error"] = "Please select file to upload";
            this.setState({
                importpopup: importpopup
            });
        }
    }

    closeImportErrorPopup() {

        let importerrorpopup = this.state.importerrorpopup;
        importerrorpopup["visible"] = false;
        this.setState({
            importerrorpopup: importerrorpopup
        });
    }

    openImportErrorPopup(message, error_list) {

        let importerrorpopup = this.state.importerrorpopup;
        importerrorpopup["visible"] = true;
        importerrorpopup["message"] = message;
        importerrorpopup["error_list"] = error_list;
        this.setState({
            importerrorpopup: importerrorpopup
        });
    }

    closeStarStudentPopup() {

        let startstudentpopup = this.state.startstudentpopup;
        startstudentpopup["visible"] = false;
        startstudentpopup["data"] = [];
        this.setState({
            startstudentpopup: startstudentpopup
        });
    }

    onPopupCoordinatorSelected(event) {

        let startstudentpopup = this.state.startstudentpopup;
        startstudentpopup["selected_coordinator"] = event.target.value;
        startstudentpopup["selectionErrorMessage"] = "";
        this.setState({
            startstudentpopup: startstudentpopup
        });
    }

    openStarStudentPopup(user_seq, user_name, coordinatorList, isBulk) {

        let startstudentpopup = this.state.startstudentpopup;
        startstudentpopup["visible"] = true;
        startstudentpopup["selected_student_seq"] = user_seq;
        startstudentpopup["selected_student_name"] = isBulk ? "Selected Student" : user_name;
        startstudentpopup["coordinator_list"] = coordinatorList;
        startstudentpopup["isLoadingSubmit"] = false;
        startstudentpopup["isBulk"] = isBulk;
        startstudentpopup["selected_coordinator"] = -1;

        this.setState({
            startstudentpopup: startstudentpopup
        });
    }

    loadCoordinatorList(user_seq, user_name, isBulk) {

        this.setState({
            spinner: true
        });

        let connector = new ServerConnector();
        let dataMap = {
            _action_code: "GET_ALL_MENTORS",
            filter_role: "COORDINATOR"
        }

        connector.postData(dataMap, (data) => { // success
            
            this.setState({
                spinner: false
            });

            var coordinatorList = [];
            for (var i=0;i<data.data.length;i++) {

                if (data.data[i].status == "ACTIVE") {
                    coordinatorList.push(data.data[i]);
                }
            }

            this.openStarStudentPopup(user_seq, user_name, coordinatorList, isBulk);

        }, (err_cd, msg, data) => { // failure

            this.setState({
                spinner: false
            });
            this.props.showAlert("Error", msg, "Ok", null, null);
        });
    }

    markStudentAsStar() {

        if (String(this.state.startstudentpopup.selected_coordinator) == "-1") {
            this.setState({
                startstudentpopup: {...this.state.startstudentpopup, selectionErrorMessage: "Please select coordinator"}
            });

            return;
        }

        this.setState({
            startstudentpopup: {...this.state.startstudentpopup, isLoadingSubmit: true}
        });

        var studentList = JSON.stringify([this.state.startstudentpopup.selected_student_seq]);
        if (this.state.startstudentpopup.isBulk) {

            var studentSeqList = [];
            this.state.selectedStudents.map((position, index) => {

                studentSeqList.push(this.state.student_list[position].user_seq);
            });
            studentList = JSON.stringify(studentSeqList);
        }

        let connector = new ServerConnector();
        let dataMap = {
            _action_code: "SET_STAR_STUDENT",
            user_seq_list: studentList,
            is_star: "YES",
            coordinator_seq: this.state.startstudentpopup.selected_coordinator
        }

        connector.postData(dataMap, (data) => { // success
            
            if (this.state.startstudentpopup.isBulk) {
                this.setState({selectedStudents: []});
            }

            this.closeStarStudentPopup();
            this.props.showAlert("Success", data.msg, "Ok", null, null);
            this.loadData();

        }, (err_cd, msg, data) => { // failure

            this.setState({
                startstudentpopup: {...this.state.startstudentpopup, isLoadingSubmit: false}
            });
            this.props.showAlert("Error", msg, "Ok", null, null);
        });
    }

    confirmRemoveStar(studentSeq, studentName) {

        this.props.showConfirmation(
            "Confirmation", 
            "Do you want to remove '"+studentName+"' as star student?", 
            "Yes", 
            "No", 
            null, 
            () => {

                this.setState({
                    spinner: true
                });
        
                let connector = new ServerConnector();
                let dataMap = {
                    _action_code: "SET_STAR_STUDENT",
                    user_seq_list: JSON.stringify([studentSeq]),
                    is_star: "NO",
                }
                
                connector.postData(dataMap, (data) => { // success
                    
                    this.setState({
                        spinner: false
                    });
                    this.props.showAlert("Success", data.msg, "Ok", null, null);
                    this.loadData();
        
                }, (err_cd, msg, data) => { // failure
        
                    this.setState({
                        spinner: false
                    });
                    this.props.showAlert("Error", msg, "Ok", null, null);
                });
            }
        );
    }

    handleStudentSelection(position, checked) {

        var selectedStudents = this.state.selectedStudents;
        var indexOfPosition = selectedStudents.indexOf(position);

        if (indexOfPosition > -1) {

            if (!checked) {

                selectedStudents.splice(indexOfPosition, 1);
            }
        }
        else {

            if (checked) {

                selectedStudents.push(position);
            }
        }

        this.setState({
            selectedStudents: selectedStudents
        });
    }

    handleBulkStar() {

        var firstSelectedStudent = "";
        if (this.state.selectedStudents.length != 0) {
            if (this.state.student_list[this.state.selectedStudents[0]].is_star == "YES") {
                firstSelectedStudent = "STAR";
            }
            else {
                firstSelectedStudent = "NOT_STAR";
            }
        }

        if (firstSelectedStudent == "STAR") {

            this.confirmBulkRemoveStar();
        }
        else {

            this.loadCoordinatorList(-1, "", true);
        }
    }
    
    confirmBulkRemoveStar() {

        var studentSeqList = [];
        this.state.selectedStudents.map((position, index) => {
            studentSeqList.push(this.state.student_list[position].user_seq);
        });

        this.props.showConfirmation(
            "Confirmation", 
            "Do you want to remove selected students as star student?", 
            "Yes", 
            "No", 
            null, 
            () => {

                this.setState({
                    spinner: true
                });
        
                let connector = new ServerConnector();
                let dataMap = {
                    _action_code: "SET_STAR_STUDENT",
                    user_seq_list: JSON.stringify(studentSeqList),
                    is_star: "NO",
                }
        
                connector.postData(dataMap, (data) => { // success
                    
                    this.setState({
                        spinner: false,
                        selectedStudents: []
                    });
                    this.props.showAlert("Success", data.msg, "Ok", null, null);
                    this.loadData();
        
                }, (err_cd, msg, data) => { // failure
        
                    this.setState({
                        spinner: false
                    });
                    this.props.showAlert("Error", msg, "Ok", null, null);
                });
            }
        );
    }

    render() {

        var firstSelectedStudent = "";
        if (this.state.selectedStudents.length != 0) {
            if (this.state.student_list[this.state.selectedStudents[0]].is_star == "YES") {
                firstSelectedStudent = "STAR";
            }
            else {
                firstSelectedStudent = "NOT_STAR";
            }
        }

        return (
            <>
                <PageHeader page_name={this.props.page_name} >
                    <AppButton
                        color="primary"
                        name="Import"
                        className="me-2"
                        icon={cilCloudDownload}
                        isLoading={false}
                        onClick={() => this.showImportPopup()} />
                    <AppButton
                        color="primary"
                        name="Add Student"
                        icon={cilPlus}
                        isLoading={false}
                        onClick={() => this.props.navigate("add_student", { user_seq: -999 })} />
                </PageHeader>
                <CRow>
                    <CCol md="3">
                        <CFormInput
                            type="text"
                            placeholder="Search"
                            onChange={(event) => { this.updateSearchInput(event) }}
                            value={this.state.search_str} />
                    </CCol>
                    <CCol md="2">
                        <AppButton
                            color="primary"
                            name="Search"
                            icon={cilSearch}
                            isLoading={false}
                            onClick={() => { this.loadData(); }} />
                    </CCol>
                    <CCol md="7">
                        <CFormCheck 
                            id="starStudent" 
                            label="Star Student"
                            onChange={(event) => {
                                this.setState({starStudentFilter: event.target.checked}, () => {this.loadData()})
                            }}
                            className="checkBoxInlineDiv"/>
                    {
                        firstSelectedStudent.length > 0 ?
                            <AppButton
                                color="primary"
                                name={firstSelectedStudent == "STAR" ? "Remove Star on Selected Students" : "Mark Selected Students As Star"}
                                icon={cilStar}
                                isLoading={false}
                                onClick={() => this.handleBulkStar()}
                                style={{marginLeft: 8}} />
                        :
                        null
                    }
                    </CCol>
                </CRow>
                {
                    this.state.spinner ?
                        <div className="spinnerHolder">
                            <CSpinner color="primary" />
                        </div>
                        : null
                }
                <CTable>
                    <CTableHead>
                        <CTableRow>
                            <CTableHeaderCell style={{ width: '25%' }} scope="col"> Name</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '25%' }} scope="col">User ID/ Roll Number</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '20%' }} scope="col">Max Questions In Queue</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '10%' }} scope="col">Class</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '10%' }} scope="col">Status</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '10%' }} scope="col">Actions</CTableHeaderCell>
                        </CTableRow>
                    </CTableHead>
                    <CTableBody>
                        {
                            this.state.student_list.map((object, index) => {
                                let menuList = [
                                    {
                                        name: "Edit",
                                        icon: cilPencil,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE",
                                        onClick: () => { this.props.navigate("add_student", { user_seq: object.user_seq }) },
                                        data: null
                                    },
                                    {
                                        name: "View",
                                        icon: cilSearch,
                                        isLoading: false,
                                        visible: true,
                                        onClick: () => { this.props.navigate("view_student", { user_seq: object.user_seq }) },
                                        data: null
                                    },
                                    {
                                        name: "Assign Batch",
                                        icon: cilLink,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE",
                                        onClick: () => { this.getLinkBatchPopup(object.user_seq, object.name) },
                                        data: null
                                    },
                                    {
                                        name: "Update Password",
                                        icon: cilLockLocked,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE",
                                        onClick: () => { this.openPasswordPopup(object.user_seq, object.name) },
                                        data: null
                                    },
                                    {
                                        name: "Mark As Star Student",
                                        icon: cilStar,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE" && object.is_star != "YES",
                                        onClick: () => { this.loadCoordinatorList(object.user_seq, object.name, false) },
                                        data: null
                                    },
                                    {
                                        name: "Remove Star Student",
                                        icon: cilStar,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE" && object.is_star == "YES",
                                        onClick: () => { this.confirmRemoveStar(object.user_seq, object.name) },
                                        data: null
                                    },
                                    {
                                        name: "Deactivate",
                                        icon: cilBan,
                                        isLoading: false,
                                        visible: object.status == "ACTIVE",
                                        onClick: () => { this.confirmStatusChange(object.user_seq, "DEACTIVATION") },
                                        data: null
                                    },
                                    {
                                        name: "Activate",
                                        icon: cilCheck,
                                        isLoading: false,
                                        visible: object.status != "ACTIVE",
                                        onClick: () => { this.confirmStatusChange(object.user_seq, "REACTIVATION") },
                                        data: null
                                    }
                                ];

                                var disableCheckBox = false;
                                if (firstSelectedStudent == "STAR") {
                                    if (object.is_star != "YES") {
                                        disableCheckBox = true;
                                    }
                                }
                                else if (firstSelectedStudent == "NOT_STAR") {
                                    if (object.is_star == "YES") {
                                        disableCheckBox = true;
                                    }
                                }

                                return (
                                    <CTableRow key={String(object.user_seq)}>
                                        <CTableDataCell>
                                        <CFormCheck 
                                            id={"markStudent"+String(object.user_seq)}
                                            label=""
                                            onChange={(event) => {
                                                this.handleStudentSelection(index, event.target.checked)
                                            }}
                                            checked={this.state.selectedStudents.indexOf(index) > -1}
                                            style={{marginRight: 5}}
                                            disabled={disableCheckBox}/>
                                            {
                                                object.is_star == "YES" ?
                                                    <CIcon icon={cilStar} style={{color: "#eb8007", marginRight: 5}} />
                                                : null
                                            }
                                            {replaceEmpty(object.name)}
                                        </CTableDataCell>
                                        <CTableDataCell>{replaceEmpty(object.email)}</CTableDataCell>
                                        <CTableDataCell className="alignCenter">{object.max_queries}</CTableDataCell>
                                        <CTableDataCell>{object.student_class && object.student_class != "0" ? object.student_class : ""}</CTableDataCell>
                                        <CTableDataCell>
                                            <CBadge color={object.status == "ACTIVE" ? "primary" : "danger"} shape="rounded-pill" size="sm">{object.status}</CBadge>
                                        </CTableDataCell>
                                        <CTableDataCell>
                                            <TableActions
                                                key={String(object.user_seq) + object.status + object.is_star}
                                                actions={menuList}
                                                minCount="1" />
                                        </CTableDataCell>
                                    </CTableRow>
                                )
                            })
                        }
                        {
                            this.state.student_list.length == 0 ?
                                <CTableRow>
                                    <CTableDataCell colSpan={5} className="alignCenter">No Data Available</CTableDataCell>
                                </CTableRow>
                                :
                                null
                        }
                    </CTableBody>
                </CTable>
                {/* <Pagination totalRows={20} /> */}
                <CModal
                    visible={this.state.passwordpopup.visible}
                    onClose={() => { this.closePasswordPopup() }} >
                    <CModalHeader>
                        <CModalTitle>Update Password for {this.state.passwordpopup.selected_student_name}</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <CRow>
                            <CCol md="12">
                                <CFormInput type="password" maxLength="64"
                                    onChange={(event) => { this.updatePasswordInput("new_password", event) }}
                                    value={this.state.passwordpopup.new_password}
                                    placeholder="Enter New Password" />
                                <div className="inputError">
                                    {this.state.passwordpopup.new_passworderr}
                                </div>
                            </CCol>
                            <CCol md="12" className="mt-3">
                                <CFormInput type="password" maxLength="64"
                                    onChange={(event) => { this.updatePasswordInput("confirmpassword", event) }}
                                    value={this.state.passwordpopup.confirmpassword}
                                    placeholder="Confirm Password" />
                                <div className="inputError">
                                    {this.state.passwordpopup.confirmpassworderr}
                                </div>
                            </CCol>
                        </CRow>
                    </CModalBody>
                    <CModalFooter>
                        <AppButton
                            size="sm"
                            name="Cancel"
                            isLoading={false}
                            onClick={() => { this.closePasswordPopup(); }} />
                        <AppButton
                            size="sm"
                            name="Submit"
                            color="primary"
                            isLoading={this.state.passwordpopup.isLoadingSubmit}
                            onClick={() => { this.validateUpdatePassword(); }} />
                    </CModalFooter>
                </CModal>

                <CModal
                    visible={this.state.linkbatchpopup.visible}
                    onClose={() => { this.closeLinkBatchPopup() }} >
                    <CModalHeader>
                        <CModalTitle>Assign Batch To {this.state.linkbatchpopup.selected_student_name}</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <CRow>
                            <CCol md="9">
                                <CFormSelect size="sm" value={this.state.linkbatchpopup.selected_batch_seq}
                                    onChange={(event) => { this.onPopupBatchSelected(event) }}>
                                    <option value="-1">Select Batch</option>
                                    {
                                        this.state.linkbatchpopup.batch_list.map((object, index) => {
                                            return (
                                                <option key={String(object.batch_seq)} value={object.batch_seq}>{object.batch_name}</option>
                                            )
                                        })
                                    }
                                </CFormSelect>
                            </CCol>
                            <CCol md="3">
                                <AppButton
                                    size="xs"
                                    name="Add"
                                    color="primary"
                                    icon={cilPlus}
                                    isLoading={this.state.linkbatchpopup.addButtonLoading}
                                    isBoldFont={false}
                                    onClick={() => this.addBatchToStudent()} />
                            </CCol>
                        </CRow>
                        <CTable className="linkSubjectTable">
                            <CTableHead>
                                <CTableRow>
                                    <CTableHeaderCell scope="col">Batch Name</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Actions</CTableHeaderCell>
                                </CTableRow>
                            </CTableHead>
                            <CTableBody>
                                {
                                    this.state.linkbatchpopup.data.map((object, index) => {
                                        let menuList = [
                                            {
                                                name: "Remove",
                                                icon: cilBan,
                                                isLoading: this.state.linkbatchpopup.removeLoadingSeq == object.batch_student_seq,
                                                visible: true,
                                                onClick: () => { this.removeBatch(object.batch_student_seq) },
                                                data: null
                                            },
                                        ];

                                        return (
                                            <CTableRow key={String(object.batch_student_seq)}>
                                                <CTableDataCell>{object.batch_name}</CTableDataCell>
                                                <CTableDataCell>
                                                    <TableActions
                                                        key={String(object.batch_student_seq) + String(this.getRandomNumber())}
                                                        actions={menuList}
                                                        minCount="1" />
                                                </CTableDataCell>
                                            </CTableRow>
                                        )
                                    })
                                }
                                {
                                    this.state.linkbatchpopup.data.length == 0 ?
                                        <CTableRow>
                                            <CTableDataCell colSpan={2} className="alignCenter">No Data Available</CTableDataCell>
                                        </CTableRow>
                                        :
                                        null
                                }
                            </CTableBody>
                        </CTable>
                    </CModalBody>
                </CModal>
                <CModal
                    visible={this.state.importpopup.visible}
                    onClose={() => { this.closeImportPopup() }} >
                    <CModalHeader>
                        <CModalTitle>Import Student Details</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <CRow>
                            <CCol md="12">
                                <CFormInput
                                    type="file"
                                    onChange={e => { this.updateImportFile(e.target.files) }} />
                                <div className="inputError">
                                    {this.state.importpopup.file_error}
                                </div>
                            </CCol>
                            <CCol md="12" className="mt-3">
                                <a href={localStorage.getItem("template_path")}>
                                    Download Format
                                </a>
                            </CCol>
                        </CRow>
                    </CModalBody>
                    <CModalFooter>
                        <AppButton
                            size="sm"
                            name="Cancel"
                            isLoading={false}
                            onClick={() => { this.closeImportPopup(); }} />
                        <AppButton
                            size="sm"
                            name="Submit"
                            color="primary"
                            isLoading={this.state.importpopup.isLoadingSubmit}
                            onClick={() => { this.validateImport(); }} />
                    </CModalFooter>
                </CModal>

                <CModal
                    visible={this.state.importerrorpopup.visible}
                    onClose={() => { this.closeImportErrorPopup() }}
                    size="lg" >
                    <CModalHeader>
                        <CModalTitle>Import Error</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <p>
                            {this.state.importerrorpopup.message}
                        </p>
                        <CTable>
                            <CTableHead>
                                <CTableRow>
                                    <CTableHeaderCell style={{ width: '20%' }} scope="col">Row Number</CTableHeaderCell>
                                    <CTableHeaderCell style={{ width: '80%' }} scope="col">Error Messages</CTableHeaderCell>
                                </CTableRow>
                            </CTableHead>
                            <CTableBody>
                                {
                                    this.state.importerrorpopup.error_list.map((object, index) => {
                                        return (
                                            <CTableRow key={String(index)}>
                                                <CTableDataCell>{object.row}</CTableDataCell>
                                                <CTableDataCell>{object.error}</CTableDataCell>
                                            </CTableRow>
                                        )
                                    })
                                }
                            </CTableBody>
                        </CTable>
                    </CModalBody>
                    <CModalFooter>
                        <AppButton
                            size="sm"
                            name="Ok"
                            color="primary"
                            isLoading={false}
                            onClick={() => { this.closeImportErrorPopup(); }} />
                    </CModalFooter>
                </CModal>

                <CModal
                    visible={this.state.startstudentpopup.visible}
                    onClose={() => { this.closeStarStudentPopup() }} >
                    <CModalHeader>
                        <CModalTitle>Mark '{this.state.startstudentpopup.selected_student_name}' as Star Student</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <CRow>
                            <CCol md="12">
                                <CFormSelect size="sm" value={this.state.startstudentpopup.selected_coordinator}
                                    onChange={(event) => { this.onPopupCoordinatorSelected(event) }}>
                                    <option value="-1">Select Coordinator</option>
                                    {
                                        this.state.startstudentpopup.coordinator_list.map((object, index) => {
                                            return (
                                                <option key={String(object.user_seq)} value={object.user_seq}>{object.name}</option>
                                            )
                                        })
                                    }
                                </CFormSelect>
                                <div style={{color: "#F00"}}>{this.state.startstudentpopup.selectionErrorMessage}</div>
                            </CCol>
                        </CRow>
                    </CModalBody>
                    <CModalFooter>
                        <AppButton
                            size="sm"
                            name="Cancel"
                            isLoading={false}
                            onClick={() => { this.closeStarStudentPopup(); }} />
                        <AppButton
                            size="sm"
                            name="Mark As Star Student"
                            color="primary"
                            isLoading={this.state.startstudentpopup.isLoadingSubmit}
                            onClick={() => { this.markStudentAsStar(); }} />
                    </CModalFooter>
                </CModal>
            </>
        );
    }
}

export default StudentList;